export default __webpack_public_path__ + "static/media/Scouting_FINAL_2Apr.4c9a8400.png";